import { render, staticRenderFns } from "./JomBantuCert.vue?vue&type=template&id=3b50714b&"
import script from "./JomBantuCert.vue?vue&type=script&lang=js&"
export * from "./JomBantuCert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports